/* eslint-disable no-alert */
import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import imageCompression from 'browser-image-compression';

const useFileHandler = (initState) => {
  const [pdfFile, setPDFFile] = useState(initState);
  const [pdfFileName, setPDFFileName] = useState(initState);

  const [isPDFLoading, setPDFLoading] = useState(false);

  const removePDF = ({ id, name }) => {
    const items = pdfFile[name].filter((item) => item.id !== id);

    setPDFFile({
      ...pdfFile,
      [name]: items
    });
  };

  const onPDFChange = async (event, { name, type }) => {

    const val = event.target.value;
    const img = event.target.files[0];
    const regex = /(\.pdf)$/i;

    const size = img.size / 1024 / 1024;
    var newFileName = img.name.replace('.pdf','');

 console.log(newFileName)

        //console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
       // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB










    setPDFLoading(true);
    if (!regex.exec(val)) {
      alert('File type must be PDF', 'error');
      setPDFLoading(false);
    } else if (size > 5) {
      alert('File size exceeded 5 MB, consider optimizing your PDF File', 'error');
      setPDFLoading(false);
    } else if (type === 'multiple') {
      Array.from(event.target.files).forEach(async (file) => {

     //   const CFile = await imageCompression(file, options);

        const reader = new FileReader();
        reader.addEventListener('load', (e) => {
          setPDFFile((oldFiles) => ({
            ...oldFiles,
            [name]: [...oldFiles[name], {file: file, url: e.target.result, id: uuidv4() }]
          }));
        });
        reader.readAsDataURL(file);
      });

      setPDFLoading(false);
    } else { // type is single
      const reader = new FileReader();

      reader.addEventListener('load', (e) => {
        setPDFFile({
          ...pdfFile,
          [name]: { file: img, url: e.target.result }
        });
        setPDFLoading(false);
        setPDFFileName(newFileName);

      });
      reader.readAsDataURL(img);
    }
  };

  return {
    pdfFile,
    pdfFileName,
    setPDFFile,
    isPDFLoading,
    onPDFChange,
    removePDF
  };
};

export default useFileHandler;
